import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useToast } from '../../contexts/ToastContext';
import './ToastContainer.css';

// Renders active toasts in a bottom-right portal.
export default function ToastContainer() {
  const { toasts, removeToast, pauseTimer, resumeTimer } = useToast();
  const [portalEl, setPortalEl] = useState(null);

  useEffect(() => {
    let el = document.getElementById('toast-root');
    if (!el) {
      el = document.createElement('div');
      el.id = 'toast-root';
      document.body.appendChild(el);
    }
    setPortalEl(el);
  }, []);

  if (!portalEl) return null;

  return ReactDOM.createPortal(
    <div className="toast-container" aria-live="polite" aria-relevant="additions" aria-atomic="false">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`toast toast-intent-${t.intent}`}
          role="status"
          tabIndex={0}
          onMouseEnter={() => pauseTimer(t.id)}
          onMouseLeave={() => resumeTimer(t.id)}
        >
          <div className="toast-message">{typeof t.message === 'string' ? t.message : String(t.message ?? '')}</div>
          {t.action && (
            <button
              type="button"
              className="toast-action-btn"
              onClick={() => { t.action.onClick?.(); removeToast(t.id); }}
            >
              {t.action.label}
            </button>
          )}
          <button
            type="button"
            className="toast-close-btn"
            aria-label="Dismiss notification"
            onClick={() => removeToast(t.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>,
    portalEl
  );
}
